import React from 'react';
import { Link } from 'react-router-dom';
import { Headphones, DoorOpen, RotateCw, ChevronRight, Infinity as InfinityIcon, Heart, Lock } from 'lucide-react';

const Info = ({ id, Icon, title, sub, children }) => (
  <details className="mp-info" data-testid={`membership-info-${id}`}>
    <summary className="mp-info__head" data-testid={`membership-info-${id}-toggle`}>
      <Icon className="mp-info__icon" aria-hidden="true" />
      <span className="mp-info__title">{title}</span>
      <span className="mp-info__sub">{sub}</span>
      <ChevronRight className="mp-info__chev" aria-hidden="true" />
    </summary>
    <div className="mp-info__body">{children}</div>
  </details>
);

export const MembershipInfo = ({ c, plans }) => (
  <div className="mp-infos">
    <Info id="difference" Icon={Headphones} title={c.info.diff[0]} sub={c.info.diff[1]}>
      <p>{c.diffBody(Math.round((plans.shared_audio_max_seconds || 0) / 60))}</p>
    </Info>
    <Info id="next-room" Icon={DoorOpen} title={c.info.room[0]} sub={c.info.room[1]}>
      <p>{c.roomBody}</p>
    </Info>
    <Info id="renewal" Icon={RotateCw} title={c.info.renew[0]} sub={c.info.renew[1]}>
      <p data-testid="plan-details-renewal">{c.paidTerms}</p>
      <p data-testid="membership-purchase-channels">{c.channels}</p>
      <p className="mp-info__links">
        <Link to="/terms" data-testid="membership-terms-link">{c.terms}</Link>
        <span aria-hidden="true"> · </span>
        <Link to="/privacy" data-testid="membership-privacy-link">{c.privacy}</Link>
      </p>
    </Info>
  </div>
);

const PILLAR_ICONS = [InfinityIcon, Heart, Lock];
const PILLAR_IDS = ['same', 'continuity', 'control'];

export const MembershipPillars = ({ c }) => (
  <div className="mp-pillars">
    {c.pillars.map(([title, body], i) => {
      const Icon = PILLAR_ICONS[i];
      const testid = i === 1 ? 'plan-details-continuity' : `membership-pillar-${PILLAR_IDS[i]}`;
      return (
        <div className="mp-pillar" key={title} data-testid={testid}>
          <p className="mp-pillar__title"><Icon className="mp-pillar__icon" aria-hidden="true" />{title}</p>
          <p className="mp-pillar__body">{body}</p>
        </div>
      );
    })}
  </div>
);
